// extracted by mini-css-extract-plugin
export default {"page_content":"Solution_page_content__9G7Xa"};